// export const FEATURED_TAKE_OFF_SITE =
//     {
//         id: 26,
//         name: 'D01',
//         slug: 'd01',
//         image: 'nis.jpeg',
//         featuredLogo: 'EuChamp'
//     }
    export const FEATURED_TAKE_OFF_SITE = null

// Main sites displayed on homepage and in search by default
export const TAKE_OFF_SITES = [
    {
        id: 16,
        name: 'Vršac-Kula',
        slug: 'vrsac-kula',
        image: 'vrsac.webp',
        suitableWindDirections: ['NNW', 'NW'] // West-facing slope
    },
    {
        id: 14,
        name:'Zlatibor-Vojska',
        slug: 'zlatibor-vojska',
        image:'zlatibor.webp',
        // suitableWindDirections: ['N', 'NE', 'NW'] // North-facing slope
    },
    {
        id: 24,
        name:'Stolovi',
        slug: 'stolovi',
        image:'stolovi.webp',
        // suitableWindDirections: ['W', 'NW', 'SW'] // West-facing slope
    },
    {
        id: 25,
        name:'Rajac',
        slug: 'rajac',
        image:'rajac.webp',
        // suitableWindDirections: ['E', 'SE', 'NE'] // East-facing slope
    },
    {
        id: 26,
        name: 'Oreovac - Niš',
        slug: 'oreovac-nis',
        image: 'nis.webp',
        // suitableWindDirections: ['N', 'NE', 'NW'] // North-facing slope
    },
    {
        id: 30,
        name: 'Sportski aerodrom Veliki Radinci',
        slug: 'lysm',
        image: 'lysm.webp',
        // suitableWindDirections: ['N', 'NE', 'E', 'SE', 'S', 'SW', 'W', 'NW'] // All directions suitable for aerodrome
    },
    {
        id: 27,
        name: 'Šajkaš - Titelski breg',
        slug: 'titelski-breg',
        image: 'titleski-breg.webp',
        // suitableWindDirections: ['S', 'SE', 'SW'] // South-facing slope
    },
    {
        id: 33,
        name: 'Fruška gora',
        slug: 'fruska-gora',
        image: 'sakotinac.webp',
        // suitableWindDirections: ['S', 'SE', 'SW'] // South-facing slope
    },
    {
        id: 29,
        name:'Drvar-Kruškovac',
        slug: 'drvar-kruskovac',
        image:'drvar-kruskovac.webp',
        suitableWindDirections: ['S', 'SW', 'SSW']
    }
]

// Shadow sites - only shown in search when explicitly searched for
export const SHADOW_SITES = [
    // Example shadow site - add your shadow sites here
    {
        id: 42,
        name: 'Gomila - Cazin',
        slug: 'gomila',
        image: 'default.webp',
        suitableWindDirections: ['N', 'NE', 'NW'],
        shadow: true
    }
]

// Combined list of all sites (main + shadow)
export const ALL_SITES = [...TAKE_OFF_SITES, ...SHADOW_SITES]
